export default "__VITE_ASSET__npQYWkBg__"